export const PurchaseHistoryTabsIds = {
  ESIGN: 'esign',
  STAMP: 'stamp',
};
